// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dTzau","loading":"styles_loading__Hqiyg","dialog":"styles_dialog__8vlU7"};